export default "__VITE_ASSET__5SjlmF5b__"